import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { IResponse, IResponseArray } from '@data/interfaces/iresponseArray.interface'
import { environment } from '@env/environment'

@Injectable({ providedIn: 'root' })
export class ApiNotificationsService extends ApiClass {
  constructor() {
    super()
    this.path = 'notifications'
  }

  unreadCount(): Observable<IResponse> {
    return this.http.get<IResponse>(`${environment.apiUrl}${this.path}/unread-count`)
  }

  list(page = 1, limit = 20): Observable<IResponseArray> {
    return this.http.post<IResponseArray>(`${environment.apiUrl}${this.path}`, { page, limit })
  }

  markRead(id: string): Observable<IResponse> {
    return this.patchCollection({}, environment.apiUrl, `${this.path}/${id}/read`)
  }

  markAllRead(): Observable<IResponse> {
    return this.patchCollection({}, environment.apiUrl, `${this.path}/read-all`)
  }
}
